// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.address-header ion-toolbar {
  padding: 0 0.625rem;
}
ion-header.address-header ion-toolbar ion-title {
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
  color: var(--ion-color-primary-black);
}
ion-header.address-header ion-toolbar ion-title .notifications-header {
  text-transform: lowercase;
}
ion-header.address-header ion-toolbar ion-title .notifications-header::first-letter {
  text-transform: uppercase !important;
}
ion-header.address-header:after {
  height: 0 !important;
}

.main-title h2 {
  text-transform: capitalize;
}

.row-css {
  display: flex;
  align-items: center;
  width: 100%;
}

.label1 {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.label2 {
  font-size: 0.8rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}

.text-div {
  width: 70%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.time-div {
  width: 30%;
  text-align: end;
  display: grid;
  align-items: center;
}

.horizontal-line {
  border-bottom: 1px solid var(--ion-divider);
  width: 100%;
}

.main-title h2 {
  font-weight: bold;
  font-size: 2.625rem;
  color: var(--ion-color-primary-black);
  margin: 0 0 1.875rem;
}

@media screen and (max-width: 600px) {
  .time-div {
    width: 30%;
    display: flex;
    justify-content: flex-end;
  }
  .p-0 {
    padding: 0 !important;
  }
  .label1 {
    padding: 0.1875rem 0;
  }
}
.listing-table {
  padding: 0 0 1.25rem;
}
.listing-table .table {
  width: 100%;
}
.listing-table .table .column-heading {
  font-weight: 400;
  font-size: 0.975rem;
  line-height: 16px;
  text-transform: uppercase;
  color: var(--ion-grey1);
  padding: 0.75rem 0.5625rem 0.75rem 0;
}
.listing-table .table .order-id-col {
  font-weight: bold !important;
  max-width: 160px;
  width: 150px;
}
.listing-table .table .date-col {
  max-width: 170px;
  width: 160px;
}
.listing-table .table .status-col {
  max-width: 110px;
  width: 100px;
}
.listing-table .table .ship-to-col {
  min-width: 280px;
  max-width: 300px;
}
.listing-table .table .order-total-col {
  max-width: 130px;
  width: 120px;
}
.listing-table .table .download-col {
  min-width: 50px;
  max-width: 3.75rem;
}
.listing-table .table .arrow-col {
  width: 25px;
  min-width: 35px;
  max-width: 40px;
}
.listing-table .table .table-body {
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.listing-table .table .table-body .border-top {
  border-top: 1px solid var(--ion-divider);
}
.listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-divider);
  cursor: pointer;
  background: var(--white-grey);
}
.listing-table .table .table-body .table-row td {
  padding: 0.6875rem 0.5625rem 1.125rem 0;
  font-weight: 450;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-primary-black);
}
.listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.listing-table .table .table-body .table-row:hover {
  background: white;
}

.justify-end {
  justify-content: flex-end;
  display: flex;
}

.justify-start {
  justify-content: flex-start;
  display: flex;
}

.notification-content {
  padding-top: 1rem;
  height: 100%;
  overflow: auto;
}

.no-record {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-no-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 56px);
}

.pl-10 {
  padding-left: 0.625rem !important;
}

ion-badge {
  --background: var(--ion-orange-primary);
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.3125rem;
  font-size: 0.75rem;
  width: fit-content;
  padding: 10px;
}

.align-end {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notification-category/notification-category.component.scss"],"names":[],"mappings":"AACC;EACC,mBAAA;AAAF;AAEE;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;AAAH;AAEG;EACC,yBAAA;AAAJ;AAEI;EACC,oCAAA;AAAL;AAMC;EACC,oBAAA;AAJF;;AASC;EACC,0BAAA;AANF;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AAPD;;AAUA;EACC,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAPD;;AAUA;EACC,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAPD;;AAUA;EACC,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAPD;;AAUA;EACC,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAPD;;AAUA;EACC,2CAAA;EACA,WAAA;AAPD;;AAWC;EACC,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;AARF;;AAYA;EACC;IACC,UAAA;IACA,aAAA;IACA,yBAAA;EATA;EAYD;IACC,qBAAA;EAVA;EAaD;IACC,oBAAA;EAXA;AACF;AAeA;EACC,oBAAA;AAbD;AAeC;EACC,WAAA;AAbF;AAeE;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oCAAA;AAbH;AAgBE;EACC,4BAAA;EACA,gBAAA;EACA,YAAA;AAdH;AAiBE;EACC,gBAAA;EACA,YAAA;AAfH;AAkBE;EACC,gBAAA;EACA,YAAA;AAhBH;AAmBE;EACC,gBAAA;EACA,gBAAA;AAjBH;AAoBE;EACC,gBAAA;EACA,YAAA;AAlBH;AAqBE;EACC,eAAA;EACA,kBAAA;AAnBH;AAsBE;EACC,WAAA;EACA,eAAA;EACA,eAAA;AApBH;AAuBE;EACC,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AArBH;AAwBG;EACC,wCAAA;AAtBJ;AAyBG;EACC,2CAAA;EACA,eAAA;EACA,6BAAA;AAvBJ;AAyBI;EACC,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qCAAA;AAvBL;AA0BI;EACC,aAAA;EACA,mBAAA;AAxBL;AA6BG;EACC,iBAAA;AA3BJ;;AAiCA;EACC,yBAAA;EACA,aAAA;AA9BD;;AAiCA;EACC,2BAAA;EACA,aAAA;AA9BD;;AAiCA;EACC,iBAAA;EACA,YAAA;EACA,cAAA;AA9BD;;AAiCA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9BD;;AAiCA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AA9BD;;AAiCA;EACC,iCAAA;AA9BD;;AAiCA;EACC,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AA9BD;;AAiCA;EACC,aAAA;EACA,yBAAA;AA9BD","sourcesContent":["ion-header.address-header {\n\tion-toolbar {\n\t\tpadding: 0 0.625rem;\n\n\t\tion-title {\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 1.25rem;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-primary-black);\n\n\t\t\t.notifications-header {\n\t\t\t\ttext-transform: lowercase;\n\n\t\t\t\t&::first-letter {\n\t\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&:after {\n\t\theight: 0 !important;\n\t}\n}\n\n.main-title {\n\th2 {\n\t\ttext-transform: capitalize\n\t}\n}\n\n.row-css {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.label1 {\n\tfont-size: 1rem;\n\tfont-weight: 500;\n\tmargin: 0;\n\tpadding: 0;\n\twhite-space: nowrap;\n}\n\n.label2 {\n\tfont-size: 0.8rem;\n\tfont-weight: 500;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.text-div {\n\twidth: 70%;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 1;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.time-div {\n\twidth: 30%;\n\ttext-align: end;\n\tdisplay: grid;\n\talign-items: center;\n}\n\n.horizontal-line {\n\tborder-bottom: 1px solid var(--ion-divider);\n\twidth: 100%;\n}\n\n.main-title {\n\th2 {\n\t\tfont-weight: bold;\n\t\tfont-size: 2.625rem;\n\t\tcolor: var(--ion-color-primary-black);\n\t\tmargin: 0 0 1.875rem;\n\t}\n}\n\n@media screen and (max-width: 600px) {\n\t.time-div {\n\t\twidth: 30%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t}\n\n\t.p-0 {\n\t\tpadding: 0 !important;\n\t}\n\n\t.label1 {\n\t\tpadding: 0.1875rem 0;\n\t}\n\n}\n\n.listing-table {\n\tpadding: 0 0 1.25rem;\n\n\t.table {\n\t\twidth: 100%;\n\n\t\t.column-heading {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 0.975rem;\n\t\t\tline-height: 16px;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-grey1);\n\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t}\n\n\t\t.order-id-col {\n\t\t\tfont-weight: bold !important;\n\t\t\tmax-width: 160px;\n\t\t\twidth: 150px;\n\t\t}\n\n\t\t.date-col {\n\t\t\tmax-width: 170px;\n\t\t\twidth: 160px;\n\t\t}\n\n\t\t.status-col {\n\t\t\tmax-width: 110px;\n\t\t\twidth: 100px;\n\t\t}\n\n\t\t.ship-to-col {\n\t\t\tmin-width: 280px;\n\t\t\tmax-width: 300px;\n\t\t}\n\n\t\t.order-total-col {\n\t\t\tmax-width: 130px;\n\t\t\twidth: 120px;\n\t\t}\n\n\t\t.download-col {\n\t\t\tmin-width: 50px;\n\t\t\tmax-width: 3.75rem;\n\t\t}\n\n\t\t.arrow-col {\n\t\t\twidth: 25px;\n\t\t\tmin-width: 35px;\n\t\t\tmax-width: 40px;\n\t\t}\n\n\t\t.table-body {\n\t\t\tfont-size: 1rem;\n\t\t\tletter-spacing: 0;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\topacity: 1;\n\n\n\t\t\t.border-top {\n\t\t\t\tborder-top: 1px solid var(--ion-divider);\n\t\t\t}\n\n\t\t\t.table-row {\n\t\t\t\tborder-bottom: 1px solid var(--ion-divider);\n\t\t\t\tcursor: pointer;\n\t\t\t\tbackground: var(--white-grey);\n\n\t\t\t\ttd {\n\t\t\t\t\tpadding: 0.6875rem 0.5625rem 1.125rem 0;\n\t\t\t\t\tfont-weight: 450;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t}\n\n\t\t\t\t.right-arrow {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t\t.table-row:hover {\n\t\t\t\tbackground: white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n\tdisplay: flex;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n\tdisplay: flex;\n}\n\n.notification-content {\n\tpadding-top: 1rem;\n\theight: 100%;\n\toverflow: auto\n}\n\n.no-record {\n\theight: 300px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.mobile-no-notification {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: calc(100vh - 56px);\n}\n\n.pl-10 {\n\tpadding-left: 0.625rem !important;\n}\n\nion-badge {\n\t--background: var(--ion-orange-primary);\n\t--padding-start: 0;\n\t--padding-end: 0;\n\t--padding-top: 0;\n\t--padding-bottom: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 1.3125rem;\n\tfont-size: 0.75rem;\n\twidth: fit-content;\n\tpadding: 10px;\n}\n\n.align-end {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
